<template>
  <label class="d-flex" v-if="label || !valid_input"
    ><span>{{ label | t }}</span>
    <button
      class="btn btn-outline-info btn-sm font-weight-light ml-auto"
      v-if="revert_to_original && !is_not_translated && default_value !== null"
      :title="to_default_text"
      @click="revert()"
    >
      <i class="fa fa-question-circle-o"></i><span>{{ 'to_default' | t }}</span>
    </button>
    <span class="form-text text-danger" v-if="!valid_input">
      <i class="fa fa-exclamation-circle mr-2"></i><span>{{ 'invalid_input' | t }}</span>
    </span>
  </label>
</template>
<script>
export default {
  props: {
    label: {
      type: String | null,
      required: true
    },
    valid_input: {
      type: Boolean,
      required: false,
      default: true
    },
    value: {
      type: String | null,
      required: false,
      default: null
    },
    default_value: {
      type: String | null,
      required: false,
      default: null
    },
    display_when_not_translated: {
      type: Boolean,
      required: false,
      default: true
    },
    revert_to_original: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    is_not_translated() {
      return this.default_value === this.value;
    },
    /**
     * @return {string}
     */
    to_default_text() {
      return `Set to default value: "${this.default_value}"`;
    }
  },
  methods: {
    revert() {
      this.$emit('revert', this.default_value);
    }
  }
};
</script>
